import { render } from "./SidebarTable.vue?vue&type=template&id=51b2856c"
import script from "./SidebarTable.vue?vue&type=script&lang=js"
export * from "./SidebarTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaspur/Code/online-alv/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__